import Draft from "draft-js";
import LinkifyIt from "linkify-it";
import { once } from "lodash";
import { InlineLink } from "@sonder/editor/source/core/components/Link/InlineLink";

// Using Linkify-it to parse inline links as the user types. Decorators are run
// on content change, so we don't want to keep re-initializing Linkify.
const linkify = once(() => new LinkifyIt());
export const inlineLinkDecorator: Draft.DraftDecorator = {
  strategy: (contentBlock, callback) => {
    const text = contentBlock.getText();
    // Parse the current block for inline links. Returns a list of ranges.
    const matches = linkify().match(text) || [];
    matches.forEach(({ index: start, lastIndex: end }) => callback(start, end));
  },
  component: InlineLink,
};
